/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2025, Zumper
 */

import type { SSRLoadDataExtras } from '@zcode/nr/es/shared/packages/load-data'

export const DISMISS_APP_BANNER = 'dismissAppBanner'

export const isBannerDismissed = (ssrLoadDataExtras?: SSRLoadDataExtras | undefined) => {
  if (ssrLoadDataExtras?.req) {
    ssrLoadDataExtras.res.vary(`x-zumper-cookie-${DISMISS_APP_BANNER}`)
    return (
      ssrLoadDataExtras.req.headers[`x-zumper-cookie-${DISMISS_APP_BANNER.toLowerCase()}`] ===
      'true'
    )
  }
  return (
    typeof document !== 'undefined' &&
    document.cookie
      .split(';')
      .map((cookie) => {
        cookie = cookie.trim()
        const split = cookie.indexOf('=')
        return [cookie.substring(0, split), cookie.substring(split + 1)] as const
      })
      .find(([name]) => name === DISMISS_APP_BANNER)?.[1] === 'true'
  )
}
